<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_qiug" v-loading="loading">
            <div class="qiug_tit">
                <p>报价列表</p>
            </div>
            <!--...报价信息...-->
            <div class="qiug_baojia_msg">
                <div class="qiug_bj_p01">
                    <p>{{model.categoryname}}  {{model.attr_value_name}}</p>
                    <p>
                        <span>{{count}}条报价</span>
                        <span>{{statename}}</span>
                    </p>
                </div>
                <p class="qiug_bj_p02"> {{model.number}}{{model.unit}}</p>
                <div class="qiug_bj_p03">
                    <p>
                        <span>期望货源地：</span>
                        <span>{{model.areaname}}</span>
                    </p>
                    <p>
                        <span>备注：</span>
                        <span>{{model.remark}}</span>
                    </p>
                </div>
                <div class="qiug_bj_p03">
                    <p>
                        <span>收货地：</span>
                        <span>{{model.address}}</span>
                    </p>
                    <p>
                        <span>求购时间：</span>
                        <span>{{ $util.timeStampTurnTime(model.createtime, 'YYYY-MM-DD') }}</span>
                    </p>
                </div>
            </div>
            <!--...报价数据...-->
            <div class="qiug_baojia_num" v-for="item in priceList" :key="item.id">
                <img :src="item.avatar ? $util.img(item.avatar) : $util.img(defaultShopImage)" class="qiug_bj_num01" />
                <div class="qiug_bj_num02">
                    <p>{{item.shop.site_name}}</p>
                    <!-- <p>陕西省西安市雁塔区</p> -->
                    <p>{{item.remark}}</p>
                </div>
                <p class="qiug_bj_num03"><span>{{item.price}}</span><span>{{item.unit}}</span></p>
                <a class="qiug_bj_num04" href="javascript:void(0)" @click="service_link(item.shop)"><img src="@/assets/styles/picture/me_icon17.png" />聊一聊</a>
            </div>
        </div>
        <!--联系客服弹窗-->
		<servicerMessage ref="servicerMessage" class="kefu" :shop="{shop_id:shopInfo.site_id,logo:shopInfo.logo,shop_name:shopInfo.site_name}"></servicerMessage>
    </div>
</template>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import { purchaseDetail, quotationList } from '@/api/purchase/purchase';
    import { shopServiceOpen } from "@/api/website.js";
    import { getToken } from "@/utils/auth.js";
    import util from '@/utils/util.js';
    import servicerMessage from "@/components/message/servicerMessage";
    import { mapGetters } from "vuex";

    export default {
        name: "",
        components: {
            servicerMessage
        },
        data: () => {
            return {
                priceList:[],
                loading:true,
                id:0,
                model:{},
                count:'',
                statename:'',
                shopInfo:{},
            }
        },
        created() {
           this.id = this.$route.query.id;
           this.token = getToken();
           this.getDetails();
           this.getPriceList();
        },
        computed: {
            ...mapGetters([ "defaultShopImage"])
	    },
        methods: {
            getDetails() {
                purchaseDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        console.log(this.model);
                        if(this.model.isshow == 0) {
                            this.statename = '已下架';
                        }
                        else {
                            this.statename = this.model.state == 1 ? '采购中' : (this.model.state == 0 ? '审核中' : '已驳回');
                        }
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                })
            },
            getPriceList() {
                quotationList({
                    pid: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.priceList = res.data;
                        this.count = res.data.length;
                    }
                })
            },
            service_link(shop) {
                this.shopInfo = shop;
                if (!util.isEmpty(this.token)) {
                    shopServiceOpen().then((res) => {
                        if (res.code == 0) {
                            if (res.data.type == 'third') {
                                window.open(res.data.third, "_blank");
                            } else if (res.data.type == 'system') {
                                this.$refs.servicerMessage.show()
                            }
                        }
                    })
                } else {
                    this.$message({
                        message: "您还未登录",
                        type: "warning"
                    })
                }
            },
        },
        mounted() {

		},
    }
</script>